import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/tailwind/Button'
import { Heading } from '../../../../components/ui/Heading'
import { getVariantStyles } from '../../utils'

export default function InviteDemoTalentMessage({ className, onClick }) {
  const { t } = useTranslation()

  const talents = [
    {
      score: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.0.score'
      ),
      name: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.0.name'
      ),
      talent_id: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.0.talent_id'
      )
    },
    {
      score: 60,
      name: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.1.name'
      ),
      talent_id: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.1.talent_id'
      )
    },
    {
      score: 30,
      name: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.2.name'
      ),
      talent_id: t(
        'discover.assistant.system_message.last_step.invite_talent_message.talents.2.talent_id'
      )
    }
  ]

  const getVariant = (score) => {
    if (score >= 70) return 'success'
    else if (score > 30 && score < 70) return 'warning'
    // score <= 30
    else return 'danger'
  }

  return (
    <div
      className={clsx(
        'w-full rounded-lg border border-lightGrey bg-paleWhiteBlue/40 p-4',
        className
      )}
    >
      <span className='text-sm font-normal text-darkBlack'>
        {t(
          'discover.assistant.system_message.last_step.invite_talent_message.description'
        )}
      </span>
      <div className='mt-4 flex flex-col gap-y-3'>
        {talents.map((talent, index) => (
          <div className='flex flex-row items-center' key={talent.talent_id}>
            <div
              className={clsx(
                'flex h-10 w-14 flex-col items-center justify-center rounded-[4px]',
                getVariantStyles(getVariant(talent.score))
              )}
            >
              <span className='block text-[9px] font-medium'>Score</span>
              <span className='block text-sm font-medium'>{talent.score}</span>
            </div>
            <div className='ml-3 flex flex-col'>
              <Heading level={5}>{talent.name}</Heading>
              <span className='text-sm font-normal text-[#6B7280]'>
                {talent.talent_id}
              </span>
            </div>
          </div>
        ))}
      </div>
      <p className='mt-4 text-xs/normal text-gray-500'>
        Das sind nur Beispiel-Talente. Im späteren Verlauf lädst du echte
        Talente via E-Mail oder Link ein.
      </p>
      <Button.PrimaryLG
        text={t(
          'discover.assistant.system_message.last_step.invite_talent_message.cta'
        )}
        onClick={onClick}
        className={'mt-6 w-full'}
      />
    </div>
  )
}
